import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

export const useDancerAuth = (dancerName = null) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [claimStatus, setClaimStatus] = useState(null);
  const [claimData, setClaimData] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      setUser(authUser);
      
      if (authUser) {
        // Check if user is admin
        try {
          const userDoc = await getDoc(doc(db, 'users', authUser.uid));
          const isAdminByEmail = authUser.email === 'giannisaliev@gmail.com';
          const isAdminByDoc = userDoc.exists() && userDoc.data().isAdmin === true;
          setIsAdmin(isAdminByEmail || isAdminByDoc);
        } catch (error) {
          console.error('Error checking admin status:', error);
          setIsAdmin(false);
        }

        // Check claim status for this dancer if dancerName provided
        if (dancerName) {
          try {
            const claimsQuery = query(
              collection(db, 'profileClaims'),
              where('dancerName', '==', dancerName),
              where('userId', '==', authUser.uid)
            );
            const claimsSnapshot = await getDocs(claimsQuery);
            
            if (!claimsSnapshot.empty) {
              const claimDoc = claimsSnapshot.docs[0];
              const data = claimDoc.data();
              setClaimStatus(data.status);
              setClaimData({
                id: claimDoc.id,
                rejectionReasons: data.rejectionReasons || [],
                rejectedAt: data.rejectedAt || data.updatedAt,
                ...data
              });
            }
          } catch (error) {
            console.error('Error checking claim status:', error);
          }
        }
      } else {
        setIsAdmin(false);
        setClaimStatus(null);
        setClaimData(null);
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, [dancerName]);

  return { user, loading, claimStatus, claimData, isAdmin };
};
